export default from './full-screen-window';



// WEBPACK FOOTER //
// ./app/components/full-screen-window/index.js